/* eslint-disable */
export default [
  {
    id: 1,
    icon: 'exchange',
    left: '310px',
    top: '610px',
    detail: {
      icon: 'exchange',
      title: 'exchange-ecosystemData-binance',
      description: 'exchange-ecosystemData-binanceExchangeIs',
      url: 'trade/BTC_USDT',
      ecosystemDataId: 'ecosystemDataId-a-exchangeViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '379.18px',
        top: '601.91px',
      },
      {
        id: 2,
        text: '·',
        left: '444.63px',
        top: '578.08px',
      },
    ],
  },
  {
    id: 2,
    icon: 'academy',
    left: '502.83px',
    top: '539.81px',
    detail: {
      icon: 'academy',
      title: 'exchange-ecosystemData-academy',
      description: 'exchange-ecosystemData-openLearning',
      url: 'https://www.binance.vision',
      ecosystemDataId: 'ecosystemDataId-a-academyViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '550.63px',
        top: '489.14px',
      },
      {
        id: 2,
        text: '·',
        left: '585.46px',
        top: '428.82px',
      },
    ],
  },
  {
    id: 3,
    icon: 'bcf',
    left: '605.44px',
    top: '362.09px',
    detail: {
      icon: 'bcf',
      title: 'exchange-ecosystemData-charity',
      description: 'exchange-ecosystemData-nonProfitFoundation',
      url: 'https://www.binance.charity',
      ecosystemDataId: 'ecosystemDataId-a-charityViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '609.49px',
        top: '292.55px',
      },
      {
        id: 2,
        text: '·',
        left: '597.39px',
        top: '223.95px',
      },
    ],
  },
  {
    id: 4,
    icon: 'info',
    left: '569.8px',
    top: '160px',
    detail: {
      icon: 'info',
      title: 'exchange-ecosystemData-info',
      description: 'exchange-ecosystemData-informationPlatform',
      url: 'https://info.binance.com',
      ecosystemDataId: 'ecosystemDataId-a-infoViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '528.21px',
        top: '104.12px',
      },
      {
        id: 2,
        text: '·',
        left: '474.85px',
        top: '59.35px',
      },
    ],
  },
  {
    id: 5,
    icon: 'labs',
    left: '412.6px',
    top: '28.09px',
    detail: {
      icon: 'labs',
      title: 'exchange-ecosystemData-labs',
      description: 'exchange-ecosystemData-blockchainIncubation',
      url: 'https://labs.binance.com',
      ecosystemDataId: 'ecosystemDataId-a-labsViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '344.82px',
        top: '12.02px',
      },
      {
        id: 2,
        text: '·',
        left: '275.17px',
        top: '12.02px',
      },
    ],
  },
  {
    id: 6,
    icon: 'launchpad',
    left: '207.39px',
    top: '28.09px',
    detail: {
      icon: 'launchpad',
      title: 'exchange-ecosystemData-launchpad',
      description: 'exchange-ecosystemData-tokenPublishingPlatform',
      url: 'https://launchpad.binance.com',
      ecosystemDataId: 'ecosystemDataId-a-launchpadViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '145.14px',
        top: '59.35px',
      },
      {
        id: 2,
        text: '·',
        left: '91.78px',
        top: '104.12px',
      },
    ],
  },
  {
    id: 7,
    icon: 'research',
    left: '50.19px',
    top: '159.99px',
    detail: {
      icon: 'research',
      title: 'exchange-ecosystemData-research',
      description: 'exchange-ecosystemData-structureStudyReport',
      url: 'https://research.binance.com',
      ecosystemDataId: 'ecosystemDataId-a-researchViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '22.6px',
        top: '223.95px',
      },
      {
        id: 2,
        text: '·',
        left: '10.5px',
        top: '292.55px',
      },
    ],
  },
  {
    id: 8,
    icon: 'trust-wallet',
    left: '14.55px',
    top: '362.09px',
    detail: {
      icon: 'trust-wallet',
      title: 'exchange-ecosystemData-trustWallet',
      description: 'exchange-ecosystemData-wallet',
      url: 'https://trustwalletapp.com',
      ecosystemDataId: 'ecosystemDataId-a-trustWalletViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '34.53px',
        top: '428.82px',
      },
      {
        id: 2,
        text: '·',
        left: '69.36px',
        top: '489.14px',
      },
    ],
  },
  {
    id: 9,
    icon: 'Chainiconcutout',
    left: '117.16px',
    top: '539.81px',
    detail: {
      icon: 'Chainiconcutout',
      title: 'exchange-ecosystemData-title',
      description: 'exchange-ecosystemData-decentralizedExchange',
      url: 'https://explorer.binance.org/',
      ecosystemDataId: 'ecosystemDataId-a-ChainiconcutoutViewAll',
    },
    dot: [
      {
        id: 1,
        text: '·',
        left: '175.36px',
        top: '578.08px',
      },
      {
        id: 2,
        text: '·',
        left: '240.81px',
        top: '601.91px',
      },
    ],
  },
];
